import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0076',
    ecrans: ['00-2']
});
